module.exports = __webpack_public_path__ + "img/ordenarCategoria.774a9d6b.svg";